const AUTH_RETURN_BASE = "https://ariaflow.local";

export function getSafeAuthReturnPath(
  value: string | null | undefined,
  fallback: string,
) {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return fallback;
  }

  try {
    const decoded = decodeURIComponent(value);
    if (
      decoded.startsWith("//") ||
      decoded.includes("\\") ||
      /[\u0000-\u001f\u007f]/.test(decoded)
    ) {
      return fallback;
    }

    const parsed = new URL(value, AUTH_RETURN_BASE);
    if (parsed.origin !== AUTH_RETURN_BASE) return fallback;
  } catch {
    return fallback;
  }

  return value;
}
